<ng-container rtBlock="sc-toggle">
    <span rtElem="text">
        <label rtElem="label" [attr.for]="inputId">{{ label() }}</label>
        <ng-content select="[slot=hint]" />
    </span>
    <rt-toggle-switch
        rtElem="switch"
        [inputId]="inputId"
        [disabled]="disabled()"
        [ngModel]="checked()"
        (ngModelChange)="checkedChange.emit($event)" />
</ng-container>
